import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

const apiUrl = process.env.REACT_APP_API_URL;

interface DailyCommissionData {
  total_transactions: number;
  total_commission: number;
  year: number;
  month: number;
  day: number;
}

interface DailyCommissionResponse {
  data: DailyCommissionData[];
}

const useFetchDailyCommission = () => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const [dailyCommission, setDailyCommission] = useState<DailyCommissionData[] | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | undefined | null>(null);

  useEffect(() => {
    const fetchDailyCommission = async () => {
      try {
        const tk = await getAccessTokenSilently();
 
        const response = await axios.get<DailyCommissionResponse>(
          `${apiUrl}/api/v1/admin/profile/commission/daily`,
          {
            headers: {
              Authorization: `Bearer ${tk}`,
            },
          }
        );
        setDailyCommission(response.data.data);
      } catch (err) {
        setError("Error fetching daily commission");
      } finally {
        setLoading(false);
      }
    };

    if (isAuthenticated) {
      fetchDailyCommission();
    }
  }, [isAuthenticated, getAccessTokenSilently]);

  return { dailyCommission, loading, error };
};

export default useFetchDailyCommission;
